module.exports = __webpack_public_path__ + "img/mission-msg.c0a32b55.png";